import React from 'react';
import { BreakdownStep } from '.';

export const BreakdownSteps: React.FC<{ currentStep: number }> = ({ currentStep }) => (
  <div className="w-full flex mb-14 md:my-10 justify-center items-center px-4">
    {renderStep(1, 'Choisir mon produit', currentStep)}
    {renderConnector(currentStep > 1)}
    {renderStep(2, 'Décrire ma panne', currentStep)}
    {renderConnector(currentStep > 2)}
    {renderStep(3, 'Vérifier mes informations', currentStep)}
    {renderConnector(currentStep > 3)}
    {renderStep(4, 'Se faire rappeler', currentStep)}
  </div>
);

const renderStep = (stepNumber: number, stepName: string, currentStep: number) => (
  <BreakdownStep
    stepNumber={stepNumber}
    stepName={stepName}
    type={currentStep === stepNumber ? 'PRESENT' : currentStep > stepNumber ? 'PAST' : 'FUTUR'}
  />
);

const renderConnector = (isActive: boolean) => (
  <span data-testid="connector" className={`h-0.5 ${isActive ? 'bg-navy-blue' : 'bg-light-silver'} md:w-[148px] w-[45px]`} />
);
